import React from 'react';
import {Route, BrowserRouter, Switch} from 'react-router-dom';
import ScrollToTop from './components/common/ScrollToTop';
import Index from './pages/Index';
import Impact from './pages/Impact';
import AppFooter from './components/global/AppFooter';
// import VerticalLines from './components/global/VerticalLines';
import './assets/styles/index.scss';

function App() {
	return (
		<div className="App">
			<BrowserRouter>
				<ScrollToTop>
					{/* <VerticalLines /> */}
					<Switch>
						<Route path="/" exact component={Index} />
						<Route path="/impact" exact component={Impact} />
					</Switch>
					<AppFooter />
				</ScrollToTop>
			</BrowserRouter>
		</div>
	);
}

export default App;
